import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ErrorService} from "../core/error/error.service";
import {FormsModule} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import {TaskListComponent} from "./task-list/task-list.component";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {ErrorComponent} from "../core/error/error.component";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        FormsModule,
        TranslatePipe,
        TaskListComponent,
        ErrorComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

    searchText: string = "";

    error: boolean = false;

    constructor(
        private errorService: ErrorService
    ) {
    }

    ngOnInit(): void {
        this.errorService.getError().subscribe(error => {
            this.error = error;
        })
    }

    protected hasSearchText() {
        return this.searchText && this.searchText.length > 0;
    }

}
